import { DestinationParams, DestinationParamsState, EditDestinationMeta } from '@anm/api/modules/stream';
import { useEffect } from 'react';

type K = keyof Omit<EditDestinationMeta, 'destinationIds'>;

const getNewParams = (key: string, keyValue: string, destinationParams: DestinationParamsState) => {
  const keys = Object.keys(destinationParams);

  const newParams = keys.reduce((acc, k) => {
    const isSameAsMainField = destinationParams?.[k]?.sameFields?.includes(key);

    const newValue = isSameAsMainField ? keyValue : (destinationParams?.[k]?.[key as K] as string);

    acc[k] = {
      ...destinationParams?.[k],
      [key]: newValue
    };

    return acc;
  }, {} as DestinationParams);

  return newParams;
};

type HookProps = {
  name: string;
  description: string;
  preview?: string;
  destinationParams?: DestinationParamsState;
  onUpdateDestinationParams(params: DestinationParams): void;
};

const useUpdateDestinationParams = ({
  name,
  preview,
  description,
  destinationParams,
  onUpdateDestinationParams
}: HookProps) => {
  useEffect(() => {
    if (!destinationParams) return;

    const newParams = getNewParams('title', name, destinationParams);

    onUpdateDestinationParams(newParams);
  }, [name]);

  useEffect(() => {
    if (!destinationParams) return;

    const newParams = getNewParams('description', description, destinationParams);

    onUpdateDestinationParams(newParams);
  }, [description]);

  useEffect(() => {
    if (!destinationParams || preview?.includes('blob')) return;

    const newParams = getNewParams('preview', preview || '', destinationParams);

    onUpdateDestinationParams(newParams);
  }, [preview]);
};

export default useUpdateDestinationParams;
